import {
  PMSMappingListForChannel,
  RoomTypeForPMSMappingList
} from '../../types/accommodationPMSMapping'

export type ChannelOption = { label: string; value: string }

// Builds the channel rows after the channels picker changes. A channel that is
// already saved keeps exist=true, so its Save sends modify instead of create.
export const buildSelectedChannels = (
  selected: ChannelOption[],
  savedChannels: PMSMappingListForChannel[] | undefined,
  accommodationRoomTypes: RoomTypeForPMSMappingList[] | undefined
): PMSMappingListForChannel[] =>
  selected.map((option) => {
    const saved = savedChannels?.find((i) => i.AdotelCode === option.value)

    return {
      PMSCode: saved?.PMSCode || '',
      PMSPass: saved?.PMSPass,
      AdotelCode: option.value,
      AdotelName: option.label,
      Active: true,
      RoomTypes: saved?.RoomTypes || accommodationRoomTypes || [],
      isExpanded: false,
      isVisiblePassword: false,
      exist: !!saved
    }
  })
